module.exports = __webpack_public_path__ + "img/my-account-o.7398f514.svg";